import { useEffect } from "react";

import GenericTabs from "../../common/GenericTab";

const NavFirmTemplateSettingsTab = ({ sidebarItems, _handleTabChange, activeTab }) => {
  useEffect(() => {
    // const divLeft = document.querySelector('.fake-left');
    const divRight = document.querySelector(".fake-right");
    // if (activeTab === "case") {
    //     divLeft.style.setProperty('background-color', 'var(--primary)');
    // }
    // else{
    //     divLeft.style.setProperty('background-color', 'var(--primary-70)');
    // }

    if (activeTab === "objections") {
      divRight.style.setProperty("background-color", "var(--primary)");
    } else {
      divRight.style.setProperty("background-color", "var(--primary-5)");
    }
  }, [activeTab]);

  return (
    <div className="parent-action-bar-div main-action-bar position-relative d-flex justify-content-between">
      <div
        className="child-action-bar-div nav nav-tabs align-items-center height-25 position-relative overflow-visible"
        role="tablist"
      >
        <GenericTabs tabsData={sidebarItems} height={25} />
        <div
          className="fake-right"
          style={{
            position: "absolute",
            top: "0px",
            right: "-5px",
            width: "0px",
            height: "25px",
            backgroundColor: "var(--primary-70)",
            padding: "5px",
            transform: "skewX(11.31deg)",
          }}
        />
      </div>
    </div>
  );
};

export default NavFirmTemplateSettingsTab;
